<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'

import { logOut } from '@/auth'
import { deleteViewer } from '../graph/mutations/user.js'

import buyerReasons from '@/assets/buyer-delete-account-reasons'
import sellerReasons from '@/assets/seller-delete-account-reasons'

export default {
  name: 'DeleteAccountView',
  mixins: [validationMixin],
  props: {
    user: { type: Object, required: true }
  },
  data() {
    return {
      deleteReasons: this.$isBuyer ? buyerReasons : sellerReasons,

      form: {
        reason: '',
        details: ''
      },
      submitting: false
    }
  },
  methods: {
    deleteAccount() {
      if (this.submitting || this.$v.$invalid) return
      this.submitting = true

      const data = { ...this.form }
      deleteViewer(data)
        .then(() => {
          logOut()
          this.$router.replace('/')
        })
        .finally(() => (this.submitting = false))
    }
  },
  validations: {
    form: {
      reason: { required },
      details: { maxLength: maxLength(300) }
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Delete Account View -->
    <div class="view-grid">
      <div>
        <div class="display-1 font-weight-bold mb-5">
          Delete account
        </div>

        <div>
          <!-- Delete Account Message -->
          <div class="subtitle-1 font-weight-medium mt-3">
            {{ user.firstName }}, we're sorry to see you go.
          </div>

          <div class="body-2">
            Mind telling us why you are leaving?
          </div>

          <!-- Delete Account Reasons List -->
          <v-radio-group v-model="form.reason" class="reason-radio-group">
            <v-radio
              v-for="reason in deleteReasons"
              :key="reason.type"
              :value="reason.type"
              class="mt-3"
              color="error"
            >
              <template v-slot:label>
                <div class="body-2 black--text ml-2">{{ reason.title }}</div>
              </template>
            </v-radio>
          </v-radio-group>

          <!-- Delete Account Other Textarea -->
          <v-expand-transition origin="center center">
            <div v-show="form.reason === 'OTHER'" class="pt-6">
              <v-textarea
                v-model="form.details"
                outlined
                label="Please tell us why you are leaving..."
                class="details-textarea error--text"
                color="error"
                counter="300"
              />
            </div>
          </v-expand-transition>

          <!-- Delete Account Button -->
          <v-btn
            :loading="submitting"
            :disabled="$v.$invalid"
            outlined
            rounded
            class="secondary--text mt-6"
            @click="deleteAccount()"
          >
            <span :class="$v.$invalid ? '' : 'error--text'"
              >Yes, delete my account</span
            >
          </v-btn>

          <!-- Delete Account Caution Message -->
          <div class="error--text my-5 overline">
            <span class="font-weight-bold">Caution</span>: This will also delete
            your {{ $isBuyer ? 'seller' : 'buyer' }} profile.
            <span v-if="$isSeller"
              >Consider pausing sales from your Schedule page instead.</span
            >
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="sass">
.reason-radio-group
  .v-input__control > .v-input__slot
    margin-bottom: 0
  .v-messages
    display: none
</style>
